import type { AdminBootstrapInput } from '../api'
import adminBootstrapService from './admin-bootstrap.service'
import { EAdminBootstrapQueryKey } from './admin-bootstrap.types'

export const adminBootstrapOptions = (params: AdminBootstrapInput) => {
  return {
    mutationKey: [EAdminBootstrapQueryKey.ADMIN_BOOTSTRAP, params],
    mutationFn: (data: AdminBootstrapInput) =>
      adminBootstrapService.adminBootstrap(data),
  }
}
